<template>
  <div
    class="message-item-container"
    :class="[self ? 'me' : 'other', { 'block-container': show }]"
    :style="{ marginTop: `${marginTop}px`, zIndex: zIndex }"
  >
    <img v-if="displayAvatar" class="avatar" :src="avatar" alt="" />
    <div class="content">
      <div v-if="title" class="message-title">
        <div class="flex items-center">
          {{ title }}
          <span v-if="required" class="required-text">*</span>
        </div>
        <div v-if="jump" class="skip-btn" @click="clickSkipStep">跳过</div>
      </div>
      <template v-if="['text', 'over'].includes(type)">
        {{ content }}
      </template>
      <template v-if="['multiLevelPicker', 'singlePickerSelect'].includes(type)">
        <MultiLevelPicker
          :list="selectOptions"
          :placeholder="placeholder"
          :activeValue="activeValue"
          :isMultiLevel="type === 'multiLevelPicker'"
          @confirm="clickConfirm"
        />
        <div v-if="type === 'singlePickerSelect'" style="height: 20px"></div>
      </template>
      <template v-if="['inputSinglePicker', 'multiPickerInput'].includes(type)">
        <InputConfirm
          :placeholder="placeholder"
          :input-type="inputType"
          @clickConfirm="clickConfirm"
          @handleEnter="handleEnter"
        />
      </template>
      <template
        v-if="
          [
            'singlePicker',
            'inputSinglePicker',
            'multiPickerInput',
            'multiPicker',
            'singlePickerSelect',
          ].includes(type)
        "
      >
        <div class="picker-container">
          <div
            class="picker-item"
            v-for="(item, index) in options"
            :key="index"
            :class="{
              active: returnActive(item),
            }"
            @click="handleSinglePickerClick(item)"
          >
            <span class="picker-text">{{ returnPickerText(item) }}</span>
          </div>
        </div>
      </template>
      <template v-if="this.isMulti && multiValue.length">
        <div class="picker-values-content">
          <div class="multi-label">已选</div>
          <div v-for="(item, index) in multiValue" :key="index" class="multi-value-item">
            {{ item }}
            <div class="iconx-content" @click="removeMultiValue(item)">
              <span class="iconfont iconx"></span>
            </div>
          </div>
          <div v-if="!hiddenConfirmBtn" class="multi-confirm-btn" @click="clickMultiBtnConfirm">
            确认
          </div>
        </div>
      </template>
      <template v-if="type === 'over'">
        <div class="view-btn" @click="clickViewResult">立即查看</div>
      </template>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import InputConfirm from './InputConfirm.vue';
import MultiLevelPicker from './MultiLevelPicker.vue';
export default {
  name: 'MessageItem',
  components: {
    InputConfirm,
    MultiLevelPicker,
  },
  props: {
    displayAvatar: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: 'text',
    },
    content: {
      type: String,
      default: '',
    },
    self: {
      type: Boolean,
      default: false,
    },
    marginTop: {
      type: Number,
      default: 30,
    },
    title: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    selectOptions: {
      type: Array,
      default: () => [],
    },
    activeValue: {
      type: [String, Array],
      default: '',
    },
    payloadKey: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    inputType: {
      type: String,
      default: 'btn',
    },
    currentStep: {
      type: Number,
      default: 0,
    },
    resetValue: {
      type: Boolean,
      default: false,
    },
    jump: {
      type: Boolean,
      default: false,
    },
    zIndex: {
      type: Number,
      default: 31,
    },
    hiddenConfirmBtn: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: '',
      multiValue: [],
      show: true,
    };
  },
  computed: {
    ...mapState('me', ['personInfo']),
    avatar() {
      return this.self
        ? this.personInfo.avatar_url
        : 'https://logo.wondercv.com/banners/rFXnEYEDDxKYuKX.png';
    },
    isMulti() {
      return ['multiPickerInput', 'multiPicker'].includes(this.type);
    },
  },
  methods: {
    handleSinglePickerClick(item) {
      if (this.isMulti) {
        const index = this.multiValue.indexOf(item);
        if (index > -1) {
          this.multiValue.splice(index, 1);
        } else {
          this.multiValue.push(item);
        }
        if (this.hiddenConfirmBtn) {
          this.$emit('confirm', this.multiValue.join('，'), this.payloadKey, this.currentStep);
        }
      } else {
        this.$emit('confirm', item, this.payloadKey, this.currentStep);
      }
    },
    returnPickerText(data) {
      if (data instanceof Object) {
        return data.text;
      }
      return data;
    },
    clickConfirm(value) {
      this.$emit('confirm', value, this.payloadKey, this.currentStep);
    },
    handleEnter(value) {
      if (this.multiValue.includes(value)) return this.$message.error('标签已存在');
      this.multiValue.push(value);
    },
    clickSkipStep() {
      this.$emit('confirm', 'skip', this.payloadKey, this.currentStep);
    },
    returnActive(item) {
      const valueArr = this.isMulti ? this.multiValue : this.activeValue.split(',');
      if (item.value) {
        return valueArr.includes(item.value);
      } else {
        return valueArr.includes(item);
      }
    },
    removeMultiValue(value) {
      this.multiValue = this.multiValue.filter((item) => item !== value);
      if (this.hiddenConfirmBtn) {
        this.$emit('confirm', this.multiValue.join('，'), this.payloadKey, this.currentStep);
      }
    },
    clickMultiBtnConfirm() {
      this.$emit('confirm', this.multiValue.join('，'), this.payloadKey, this.currentStep);
    },
    clickViewResult() {
      this.$emit('clickViewResult');
    },
  },
  watch: {
    resetValue(newVal) {
      if (newVal) {
        this.multiValue = [];
      }
    },
  },
  mounted() {
    if (!this.self) {
      setTimeout(() => {
        this.show = true;
      }, 300);
    }
  },
};
</script>
<style lang="scss" scoped>
@import '../styles/index.scss';
.message-item-container {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  .avatar {
    width: 48px;
    height: 48px;
    border-radius: 50%;
  }
  .content {
    width: 622px;
    box-sizing: border-box;
    border: 1px solid #484e5c;
    font-size: 16px;
    line-height: 22px;
    .message-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      .required-text {
        color: #ff6644;
        margin-left: 4px;
        line-height: 12px;
      }
      .skip-btn {
        color: #9a9ca2;
        font-size: 14px;
        cursor: pointer;
        &:hover {
          color: #ff6644;
        }
      }
    }
    .picker-container {
      display: flex;
      flex-wrap: wrap;
      gap: 20px;
    }
    .picker-values-content {
      margin-top: 12px;
      overflow: hidden;
      .multi-label {
        font-size: 14px;
        color: #9a9ca2;
        float: left;
        margin-right: 8px;
        line-height: 36px;
        height: 36px;
        margin-top: 8px;
      }
      .multi-value-item {
        display: flex;
        align-items: center;
        padding: 0 12px;
        border-radius: 8px;
        background: #523433;
        font-size: 14px;
        color: #ff6644;
        height: 36px;
        float: left;
        margin-right: 8px;
        margin-top: 8px;
        cursor: pointer;
        .iconx-content {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          margin-left: 2px;
          display: flex;
          align-items: center;
          justify-content: center;
          .iconx {
            font-weight: 500;
          }
          &:hover {
            background: rgba(255, 255, 255, 0.1);
            border-radius: 50%;
            flex-shrink: 0;
          }
        }
      }
      .multi-confirm-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        float: right;
        width: 76px;
        height: 36px;
        border-radius: 6px;
        background: linear-gradient(90deg, #febe5d 0%, #e15d3f 100%);
        color: #1c212a;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        margin-top: 8px;
      }
    }
    .view-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 380px;
      height: 54px;
      border-radius: 100px;
      background: linear-gradient(90deg, #ffbe5d 0%, #f64 100%);
      color: #1c212a;
      font-size: 16px;
      font-weight: 500;
      cursor: pointer;
      margin-top: 20px;
    }
  }
  &.other {
    padding-left: 64px;
    padding-right: 114px;
    transition: all 0.6s;
    // opacity: 0;
    // transform: scale(0);
    transform-origin: left top;
    z-index: 29;
    .avatar {
      position: absolute;
      left: 0;
      top: 0;
    }
    .content {
      border-radius: 0px 12px 12px 12px;
      color: #fff;
      background: linear-gradient(79deg, #272b33 65%, #523433 100%);
      padding: 20px;
      width: fit-content;
    }
  }
  &.me {
    flex-direction: row-reverse;
    padding-left: 115px;
    padding-right: 64px;
    opacity: 1;
    z-index: 28;
    .avatar {
      position: absolute;
      right: 0;
      top: 0;
    }
    .content {
      border-radius: 12px 0px 12px 12px;
      color: #1c212a;
      background: linear-gradient(270deg, #f64 0%, #ffbe5d 100%);
      font-weight: 500;
      width: fit-content;
      padding: 14px 20px;
    }
  }
  // &.block-container {
  //   opacity: 1;
  //   transform: scale(1);
  // }
}
</style>
